"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordAttrDTO = void 0;
const options_js_1 = require("../../../../attributes/record/options.js");
const isEmpty_js_1 = require("../../../../utils/isEmpty.js");
const attribute_js_1 = require("./attribute.js");
const utils_js_1 = require("./utils.js");
/**
 * @debt feature "handle defaults, links & validators DTOs"
 */
const getRecordAttrDTO = (attr) => {
    const defaultsDTO = (0, utils_js_1.getDefaultsDTO)(attr);
    return {
        type: 'record',
        keys: (0, attribute_js_1.getAttrDTO)(attr.keys),
        elements: (0, attribute_js_1.getAttrDTO)(attr.elements),
        ...(attr.required !== options_js_1.RECORD_DEFAULT_OPTIONS.required ? { required: attr.required } : {}),
        ...(attr.hidden !== options_js_1.RECORD_DEFAULT_OPTIONS.hidden ? { hidden: attr.hidden } : {}),
        ...(attr.key !== options_js_1.RECORD_DEFAULT_OPTIONS.key ? { key: attr.key } : {}),
        ...(attr.savedAs !== undefined ? { savedAs: attr.savedAs } : {}),
        ...(!(0, isEmpty_js_1.isEmpty)(defaultsDTO) ? { defaults: defaultsDTO } : {})
    };
};
exports.getRecordAttrDTO = getRecordAttrDTO;
